export enum FieldSize {
  CUSTOM_DIRECTORY_NAME_MINIMUM = 1,
  S = 50,
  M = 150,
  L = 500,
  XL = 3000,
  RICH_TEXT = 10000,
  FILE_NAME = 200,
  CODE = 5,
}
